module.exports = {
  "$id": "mobilelogin",
  "type": "object",
  "properties": {
    "phone": {
      "title": "手机号",
      "type": "string",
      "customValidate": "mobile"
    },
    "areaCode": {
      "title": "区位码",
      "type": "string"
    }
  },
  "required": [
    "phone"
  ],
  "errorMessage": {
    "phone": {
      "required": "手机号码不能为空"
    }
  }
}
